export const setReviewsReducer = (state, action) => {
    state.reviews = action.payload;
};

export const addReviewReducer = (state, action) => {
    state.reviews[action.payload.id] = action.payload;
};

export const removeReviewReducer = (state, action) => {
    delete state.reviews[action.payload];
};

export const updateReviewReducer = (state, action) => {
    const updated = action.payload;
    if (state.reviews[updated.id]) {
        state.reviews[updated.id] = { ...state.reviews[updated.id], ...updated };
    }
};
